import { convertToPhone } from '@/configs/numbers'
export const phone = {
  bind (element, binding, vNode) {
    const phoneSpecialCharacters = [' ', '+', '(', ')', '-']
    let oldValue = ''
    let keyup = {}
    function isNotNumber (oldN, selection) {
      return phoneSpecialCharacters.includes(
        oldN.substring(selection, selection + 1)
      )
    }
    function setValue (e) {
      let value = e.target.value
      let pos = e.target.selectionStart
      const lengthValue = e.target.value.length
      if (keyup === 'Backspace' && pos !== 0) {
        if (isNotNumber(oldValue, pos)) {
          const deleteIndex = value
            .substring(0, pos)
            .replace(/\D/g, '')
            .length - 1
          const arrValue = [...value.replace(/\D/g, '')]
          arrValue.splice(deleteIndex, 1)
          value = arrValue.join('')
          pos -= 1
        }
      }
      let newValue = ''
      if (binding.arg === 'withEmail') {
        newValue = value.match(/^[\d+]/m) ? convertToPhone(value) : value
      } else {
        newValue = convertToPhone(value)
      }
      const v = vNode.data.model.expression.split('.')
      let node = new Proxy(vNode.context, {})
      for (let i = 0; i < v.length; i++) {
        if (typeof node[v[i]] === 'string') {
          node[v[i]] = newValue
        } else {
          node = new Proxy(node[v[i]], {})
        }
      }
      if (keyup !== 'Backspace') {
        pos += newValue.length - lengthValue
      }
      setTimeout(() => {
        e.target.setSelectionRange(pos, pos)
      }, 1)
    }
    element.oninput = function (e) {
      setValue(e)
    }

    element.onkeydown = function (e) {
      keyup = e.key
      oldValue = e.target.value
    }

    element.onpaste = function (e) {
      setTimeout(() => { setValue(e) }, 1)
    }
  }
}
